import { FC } from "react";

const MyAccountPage: FC = () => {
  return <div>My account page</div>;
};

export { MyAccountPage };
